import './custom_assignments' // Defines ALL (window-)global custom vars/consts: ensure to correctly overwrite below
import { overwriteColors } from './colors_tesvolt'
import { overwriteIcons } from './icons_tesvolt'

const EXTERNAL_LINKS = ['www.wendeware.com', 'www.tesvolt.com']
window.LegacyApp.EXTERNAL_LINKS = EXTERNAL_LINKS

overwriteColors()
overwriteIcons()
